<template>
    <!-- If the creator has not yet verified their email... -->
    <AccountVerificationWarning
        @verify-account="verifyEmail($root.contact)"
    />
</template>

<script>
    import _ from 'lodash';
    import AccountVerificationWarning from '../../../../../app-v2/components/data-views/dashboard/partials/AccountVerificationWarning';
    import { message } from '@grininc/grin-ui';
    import EventTrackingMixin from '../../../../../app-v2/mixins/EventTrackingMixin';

    export default {
        name: 'EmailVerification',

        components: {
            AccountVerificationWarning,
        },

        mixins: [EventTrackingMixin],

        methods: {
            async verifyEmail(payoutContact) {
                if (!payoutContact) {
                    message.error("There's a problem with your account, please contact your administrator");
                    return;
                }
                try {
                    const subdomain = window.location.hostname.split('.')[0];
                    const emailVerificationURL = this.emailVerificationUrl(payoutContact.id);
                    await this.$http.post(emailVerificationURL, { subdomain });
                    this.trackEventAccountVerificationStarted('email');
                    message.success('Email Sent!');
                } catch (e) {
                    message.error('Whoops! We could not send you an email, please reach out to support');
                }
            },

            emailVerificationUrl(contactId) {
                return `/api/v1/contacts/${contactId}/verification-email`;
            }
        },

        mounted() {
            window.addEventListener('message', (e) => {
                const data = _.get(e, 'data');

                if (data.event === 'document.height' && this.$refs.iframe) {
                    this.$refs.iframe.style.height = `${data.document.height}px`;
                }
            });
        }
    };
</script>
